import styled from 'styled-components';

export const StepOneStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-24);
  justify-content: center;
  position: relative;

  .feesBySolutionStepOne {

    &__cardContainer {
      display: flex;
      gap: var(--spacing-16);
      justify-content: center;
      position: relative;
    }
    &__card {
      width: 212px;
      padding: var(--spacing-10) var(--spacing-10) var(--spacing-16) var(--spacing-10);
    }

    &__card--disabled {
      opacity: 0.6;
      cursor: not-allowed;
      pointer-events: none;
    }

    &__cardMedia {
      min-height: 88px;
      background-color: var(--color-sonata-primary-300) !important;

      .cardMedia__icon {
        color: var(--color-sonata-li-primary-white);
      }

      &--selected {
        background-color: var(--color-sonata-interaction-400) !important;
      }
    }

    &__cardSubtext {
      display: block;
      text-align: center;
    }
  }
`;
